import Link from 'next/link';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import useLinkProps from '../../../hooks/use-link-props';
import { emails } from '../../../shared';
import DividerBottom from '../../ui/icons/dividers/bottom';
import DividerTop from '../../ui/icons/dividers/top';
import FeatureLink from '../../ui/links/featured';

const LegalContacts = () => {
  const { t } = useTranslation();
  const getLink = useLinkProps();

  return (
    <>
      <DividerTop className="text-blue-10 w-full lg:h-7 lg:transform lg:scale-x-invert" />
      <div className="bg-blue-10">
        <dl className="container lg:grid lg:grid-cols-3 m-auto px-4 lg:pt-4 lg:pb-4 text-xs">
          <div className="pt-4">
            <dt>{t('legal:main_contact.site')}</dt>
            <dd>
              <address className="not-italic">
                <Link {...getLink('index')} passHref legacyBehavior>
                  <FeatureLink variant="black">
                    https://www.b-parts.com
                  </FeatureLink>
                </Link>
              </address>
            </dd>
          </div>
          <div className="pt-4">
            <dt>
              {t('legal:main_contact.schedule', {
                timezone: `(GMT+${false ? '1' : '0'})`,
              })}
            </dt>
            <dd>{t('legal:main_contact.schedule_text')}</dd>
          </div>
        </dl>
        <DividerTop className="text-neutral-10 w-full h-7 hidden lg:block" />
      </div>
      <div className="bg-neutral-10">
        <DividerBottom className="text-blue-10 w-full lg:hidden" />
        <div className="container grid lg:grid-cols-3 px-4 m-auto text-left pt-7 lg:pt-0">
          <span className="pb-1">
            <Link {...getLink('contacts')} passHref legacyBehavior>
              <FeatureLink variant="black">{t('common:contacts')}</FeatureLink>
            </Link>
          </span>
          <span className="pb-1">
            <Link {...getLink('terms-and-conditions')} passHref legacyBehavior>
              <FeatureLink variant="black" className="pt-3 lg:pt-0">
                {t('common:terms')}
              </FeatureLink>
            </Link>
          </span>
        </div>
        <DividerTop
          className={
            'w-full text-white transform scale-x-invert lg:h-7 hidden lg:block'
          }
        />
      </div>

      <DividerTop className="text-neutral-10 w-full lg:h-7 transform scale-invert lg:transform lg:scale-y-invert lg:hidden" />
    </>
  );
};
export default LegalContacts;
